import { createAction } from 'redux-actions';

import { DUPLICATE_REQUISITION } from 'pages/AdminPortal/ToolboxRequisitionsPage/redux/actions';

export const duplicateRequisition = createAction(DUPLICATE_REQUISITION);
